import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { api } from "@/lib/api";
import { toast } from "sonner";

const inr = (n) => `₹${Number(n).toLocaleString("en-IN")}`;

export default function OrderDialog({ product, open, onOpenChange }) {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!product) return;
    setLoading(true);
    try {
      await api.post("/orders", { product_id: product.id, name, phone });
      toast.success("Order request received", {
        description: `Our team will call you back to confirm your ${product.name}.`,
      });
      setName("");
      setPhone("");
      onOpenChange(false);
    } catch (err) {
      toast.error("Could not place order request", {
        description: err?.response?.data?.detail || "Please check your details and try again.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#030A1C] border border-[#00F0FF]/15 text-white" data-testid="order-dialog">
        <DialogHeader>
          <DialogTitle className="font-disp text-2xl uppercase tracking-wide" data-testid="order-dialog-title">
            Order {product?.name}
          </DialogTitle>
          <DialogDescription className="text-white/60 text-sm">
            {inr(product?.price_inr || 0)} · Leave your details and our team will call to confirm delivery and installation.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-5 mt-2">
          <div>
            <label className="block font-mono-lbl text-xs uppercase text-white/70 mb-2" htmlFor="order-name">Full Name</label>
            <input
              id="order-name"
              required
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="e.g. Vikramaditya Sharma"
              className="w-full bg-[#061536] border border-white/20 rounded-lg px-4 py-3 text-white placeholder-white/30 focus:outline-none focus:border-[#00F0FF] text-sm"
              data-testid="order-name-input"
            />
          </div>
          <div>
            <label className="block font-mono-lbl text-xs uppercase text-white/70 mb-2" htmlFor="order-phone">Phone Number</label>
            <input
              id="order-phone"
              required
              type="tel"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              placeholder="+91 98765 43210"
              className="w-full bg-[#061536] border border-white/20 rounded-lg px-4 py-3 text-white placeholder-white/30 focus:outline-none focus:border-[#00F0FF] text-sm"
              data-testid="order-phone-input"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-[#FF2E2E] hover:bg-[#E01F1F] disabled:opacity-60 text-white py-4 rounded-lg font-mono-lbl text-xs uppercase tracking-wider font-bold shadow-lg shadow-black/30 transition-colors"
            data-testid="order-submit-btn"
          >
            {loading ? "Placing..." : "Confirm Order Request"}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
